import React from 'react'
import i18n from 'live/services/i18n'
import { ConfigProps } from './Interface'
import { FormCheckbox } from 'live/components/forms/ui/form-checkbox'

const Config = (props: ConfigProps): JSX.Element => {
    const { borderRadius, pointWidth, showCurrentDay, scrollbar, description, maxScrollbarItems } = props.config

    return (
        <div>
            <FormCheckbox
                name={name}
                checked={showCurrentDay}
                description={'Show current day line'}
                onChange={() => props.onChange('showCurrentDay', !showCurrentDay)}
                // note={''}
                disabled={false}
            />

            <FormCheckbox
                name={name}
                checked={scrollbar}
                description={'Enable scrollbar'}
                onChange={() => props.onChange('scrollbar', !scrollbar)}
                // note={''}
                disabled={false}
            />

            <FormCheckbox
                name={name}
                checked={description}
                description={'Enable chart description'}
                onChange={() => props.onChange('description', !description)}
                // note={''}
                disabled={false}
            />

            <label>Max scroll items:</label>
            <input
                type="number"
                min="1"
                value={maxScrollbarItems}
                disabled={!scrollbar}
                onChange={event => props.onChange('maxScrollbarItems', parseInt(event.target.value))}
            />

            <label>Border Radius:</label>
            <input
                type="number"
                min="0"
                value={borderRadius}
                onChange={event => props.onChange('borderRadius', parseInt(event.target.value))}
            />

            <label>Bar Width:</label>
            <input
                type="number"
                min="0"
                value={pointWidth}
                onChange={event => props.onChange('pointWidth', parseInt(event.target.value))}
            />
        </div>
    )
}

export default Config
